<script lang="js">
import PaystackPop from "@paystack/inline-js";
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Finance",
  data() {
    return {
      charges: [
        { id: 1, name: "Portal Fee", amount: 10300.00 },
        { id: 2, name: "Acceptance Fee", amount: 30000.00 },
        { id: 3, name: "Administrative Dues", amount: 2500.00 },
        { id: 4, name: "Tuition Fees", amount: 14500.00 },
      ],
      unpaidCharges: [
        { id: 2, name: "Acceptance Fee", amount: 30000.00 },
        { id: 3, name: "Administrative Dues", amount: 2500.00 },
        { id: 4, name: "Tuition Fees", amount: 14500.00 },
      ],
      paidCharges: [
        { id: 1, name: "Portal Fee", amount: 10300.00 },
      ],
      scholarships: [
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
        { id: 1, name: "FCP Scholarship", link: "https://firstcitypoly.edu.ng/funding" },
      ],
      paymentResponse: null,
    };
  },
  mounted() {
  },
  methods: {
    async payWithPaystack(charge) {
      try {
        const apiUrl = `${process.env.VUE_APP_API_BASE_URL}/payment`;

        // Generate unique reference
        const paystackRef = `FCP-${charge.id}-${new Date().getTime()}`;

        // Step 1: Call the Portal API to create a payment record
        const response = await axios.post(apiUrl,
          {
            paymentid: charge.id, // 1 for Portal/Form Fee,  2 for Acceptance Fee, 3 for Administrative Fee & 4 for Tuition/School Fees.
            payref: paystackRef, // Unique reference
            payeenum: this.user.appnum, // Application Number
            amount: charge.amount * 100,
          },
          {
            headers: { Authorization: "Bearer fcpportals@new" },
          }
        );

        console.log("API Payment Response:", response)

        // Step 2: Check if the Portal API response is successful
        if (response.data.Data !== "1") {
          Swal.fire("Payment Failed", "Could not create payment in portal.", "error");
          return;
        }

        // Step 3: If successful, proceed with Paystack payment

        const paystack = new PaystackPop();

        paystack.newTransaction({
          key: "pk_test_dd6b053b681581c95215d6fd6b5d2c74e07d4d2b", // Replace with Paystack Public Key
          email: this.user.email, // Student's email
          amount: charge.amount * 100, // Convert NGN to kobo
          currency: "NGN",
          ref: paystackRef, // Use the same reference
          onClose: () => {
            Swal.fire({
              title: "Are you sure?",
              text: "Do you really want to cancel the transaction?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, cancel it!",
              cancelButtonText: "No, continue",
            }).then((result) => {
              if (result.isConfirmed) {
                Swal.fire("Transaction Cancelled", "You have cancelled the payment.", "info");
              } else {
                Swal.fire("Resuming Transaction", "Please complete your payment.", "success").then(() => {
                  this.payWithPaystack(charge); // Retry payment
                });
              }
            });
          },
          callback: (response) => {
            this.paymentResponse = response; // Store response
            Swal.fire("Payment Successful", `Transaction Reference: ${response.reference}`, "success");
            console.log("Payment Response:", response);

            // Step 4: Verify the payment with Paystack (Optional)
            this.verifyTransaction(response.reference);
          },
        });

        // paystack.openIframe();
      } catch (error) {
        console.error("Error processing payment:", error);
        Swal.fire("Payment Error", "Something went wrong, please try again.", "error");
      }
    },

    async verifyTransaction(reference) {
      try {
        const res = await fetch(
          `https://api.paystack.co/transaction/verify/${reference}`,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer sk_test_b62f844cec8b2b8f8af1fedf264139ac89fc0f96", // Replace with your Paystack secret key
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        console.log("Verification Response:", data);
      } catch (error) {
        console.error("Verification Error:", error);
      }
    },

  },
  computed: {
    ...mapGetters(["getUser"]), // Access user data
    user() {
      return this.getUser;
    },
  },
  components: {},
};
</script>

<template>
  <div class="p-4 text-start">
    <h4 class="fw-bold">Finance</h4>
    <hr />
    <div class="col-md-7 mx-auto">
      <div class="mb-5">
        <h6 class="fw-bold">Unpaid Charges</h6>
        <ul class="list-unstyled">
          <li
            v-for="charge in unpaidCharges"
            :key="charge.id"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div>
              <p class="m-0">{{ charge.name }}</p>
              <span class="fw-bold mt-1"
                >₦{{
                  charge.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}
              </span>
            </div>
            <button
              @click="payWithPaystack(charge)"
              class="btn btn-primary btn-sm"
            >
              Pay Now
            </button>
          </li>
        </ul>
      </div>
      <div class="mb-5">
        <h6 class="fw-bold">Paid Charges</h6>
        <ul class="list-unstyled">
          <li
            v-for="charge in paidCharges"
            :key="charge.id"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div>
              <p class="m-0">{{ charge.name }}</p>
              <span class="fw-bold mt-1"
                >₦{{
                  charge.amount.toLocaleString("en-US", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })
                }}</span
              >
            </div>
            <button class="btn btn-secondary btn-sm">Print Receipt</button>
          </li>
        </ul>
      </div>
      <div class="mb-5">
        <h6 class="fw-bold">Finanial Aid/Scholarships</h6>
        <ul class="list-unstyled">
          <li
            v-for="scholarship in scholarships"
            :key="scholarship.id"
            class="d-flex justify-content-between align-items-center mb-3"
          >
            <div>
              <p class="m-0">{{ scholarship.name }}</p>

              <a
                :href="scholarship.link"
                target="_blank"
                class="text-primary small"
                rel="noopener noreferrer"
                >View Requirements</a
              >
            </div>
            <a
              :href="scholarship.link"
              target="_blank"
              class="btn btn-dark btn-sm"
              rel="noopener noreferrer"
              >Apply Now</a
            >
          </li>
        </ul>
      </div>

      <!-- Payment Response Display -->
      <div v-if="paymentResponse">
        <h4 class="text-success">Payment Successful!</h4>
        <pre>{{ paymentResponse }}</pre>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
